import { render, staticRenderFns } from "./RowConfig.vue?vue&type=template&id=dfb28456&scoped=true"
import script from "./RowConfig.vue?vue&type=script&lang=js"
export * from "./RowConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb28456",
  null
  
)

export default component.exports